export const validateLeadForm = data => {
  const res = {
    validated: true,
    text: '',
  };
  // if (!data.name.match(/^[a-zA-Z ]+$/)) {
  //   res.text = 'Name is not valid';
  //   res.validated = false;
  //   return res;
  // }
  if(data.phone.length>10) {
    res.text = 'Please enter 10 digit mobile number';
    res.validated = false;
    return res;
  }
  if (data.phone.match(/[a-zA-Z]/g)) {
    res.text = 'Please enter 10 digit mobile number';
    res.validated = false;
    return res;
  }
  if (!data.phone.match(/^[6-9][0-9]{9}$/)) {
    res.text = 'Phone Number is not valid';
    res.validated = false;
    return res;
  }
  return res;
};

export const getFiltersFromSearch = (appliedFilters, basicDetails) => {
  const tempOccasion = appliedFilters.occasions || '';
  const tempGuestsMax = appliedFilters.max_capacity || '';
  let tempBudget = '';
  let tempPackageType = '';
  if (appliedFilters.min_price && appliedFilters.max_price) {
    const { min_price: minPrice, max_price: maxPrice } = appliedFilters;
    tempBudget = `${minPrice}-${maxPrice}`;
  }
  if (basicDetails && basicDetails.packages) {
    for (let i = 0; i < basicDetails.packages.length; i++) {
      if (appliedFilters.packagetypes === (i + 1).toString()) {
        tempPackageType = basicDetails.packages[i].label;
        break;
      }
    }
  }
  return {
    occasion: tempOccasion,
    guestsmax: tempGuestsMax,
    budget: tempBudget,
    packagetype: tempPackageType,
  };
};
